import React, { useContext, useEffect, useState } from "react";
import BusinessContext from "context/BusinessContext";
import call from "../../assets/images/Icon ionic-ios-call.png";
import whatsapp from "../../assets/images/Icon simple-whatsapp.png";
import instagram from "../../assets/images/Icon simple-instagram.png";
import telegram from "../../assets/images/icons8-telegram-app-50.png";
import twitter from "../../assets/images/Icon feather-twitter.png";

import "./BusinessCover.scss";

const ModalContact = () => {
  const { contact } = useContext(BusinessContext);
  // console.log("Modalcontact", contact);
  // useEffect(() => {
  // }, [contact]);
  return (
    <>
      {contact.socialMedia instanceof Array ? (
        <div
          className="modal fade"
          id="ModalContact"
          tabIndex="-1"
          aria-labelledby="ModalContactLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="ModalContactLabel">
                  اطلاعات تماس
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div
                className="modal-body"
                style={{ textAlign: "center", fontSize: "17px" }}
              >
                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "500",
                    marginBottom: "30px",
                  }}
                >
                  فروشگاه {contact.name}
                </div>
                <hr />
                {contact.tell != "" || contact.mobile != "" ? (
                  <>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          backgroundColor: "#56A689",
                          borderRadius: "50%",
                          textAlign: "center",
                          padding: "7px",
                        }}
                      >
                        <img src={call} alt="call" width={25} height={25} />
                      </div>
                      <div>
                        {contact.tell != "" ? (
                          <>
                            <a
                              href={`tell:+98${contact.tell}`}
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                                cursor: "pointer",
                              }}
                            >
                              شماره تلفن : {contact.tell}
                            </a>
                            <br />
                          </>
                        ) : (
                          ""
                        )}
                        {contact.mobile != "" ? (
                          <a
                            href={`tell:+98${contact.mobile}`}
                            style={{
                              textDecoration: "none",
                              color: "inherit",
                              cursor: "pointer",
                            }}
                          >
                            شماره موبایل : {contact.mobile}
                          </a>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <hr />
                  </>
                ) : (
                  <>
                    <div>شماره تماسی برای این فروشگاه ثبت نشده است</div>
                    <hr />
                  </>
                )}
                <div>شبکه های اجتماعی </div>
                <div>
                  {contact.socialMedia[0].selectField == -1 &&
                  contact.socialMedia[1].selectField == -1 ? (
                    <div>شبکه اجتماعی برای این فروشگاه ثبت نشده است</div>
                  ) : (
                    contact.socialMedia.map((value, index) => {
                      return parseInt(value.selectField) == 1 ? (
                        <div key={index}>
                          <span>Instagram : {value.nameField}</span>
                          <span
                            style={{
                              cursor: "pointer",
                              borderRadius: "50%",
                              width: "50px",
                              height: "50px",
                              backgroundColor: "#F23041",
                            }}
                          >
                            <img src={instagram} alt="instagram" />
                          </span>
                        </div>
                      ) : parseInt(value.selectField) == 2 ? (
                        <div key={index}>
                          <span>Telegram : {value.nameField}</span>
                          <span
                            style={{
                              cursor: "pointer",
                              borderRadius: "50%",
                              width: "50px",
                              height: "50px",
                              backgroundColor: "#29B6F6",
                            }}
                          >
                            <img
                              src={telegram}
                              alt="telegram"
                              style={{ width: "25px", height: "25px" }}
                            />
                          </span>
                        </div>
                      ) : parseInt(value.selectField) == 3 ? (
                        <div key={index}>
                          <span>WhatsApp : {value.nameField}</span>
                          <span
                            style={{
                              cursor: "pointer",
                              borderRadius: "50%",
                              width: "50px",
                              height: "50px",
                              backgroundColor: "#56A689",
                            }}
                          >
                            <img src={whatsapp} alt="whatsapp" />
                          </span>
                        </div>
                      ) : parseInt(value.selectField) == 4 ? (
                        <div key={index}>
                          <span>Twitter : {value.nameField}</span>
                          <span
                            style={{
                              cursor: "pointer",
                              borderRadius: "50%",
                              width: "50px",
                              height: "50px",
                              backgroundColor: "#4B53F2",
                            }}
                          >
                            <img src={twitter} alt="twitter" />
                          </span>
                        </div>
                      ) : (
                        ""
                      );
                    })
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};
export default ModalContact;
